import { Rubric } from '../domain';

export const getMainRubric = (rubrics?: Rubric[]): Rubric | null =>
  rubrics && rubrics.length > 0 ? rubrics[0] : null;

export const getRubricById = (id: string, rubrics?: Rubric[]): Rubric | undefined =>
  rubrics && rubrics.length > 0
    ? rubrics.find(rubric => rubric.id === id)
    : undefined;
